var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-bar"},[_c('Score',{attrs:{"collapsed":_vm.collapsed},on:{"toggle":_vm.toggle}}),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"collapsible"},[_c('WordList',{staticClass:"word-list",attrs:{"collapsed":_vm.collapsed}}),_c('Progress',{staticClass:"progress-bar"})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }